import { render } from "./multi-selector-wrapper.vue?vue&type=template&id=0c46c15d&scoped=true&ts=true"
import script from "./multi-selector-wrapper.vue?vue&type=script&lang=ts"
export * from "./multi-selector-wrapper.vue?vue&type=script&lang=ts"

import "./multi-selector-wrapper.vue?vue&type=style&index=0&id=0c46c15d&lang=scss&scoped=true"
import "./multi-selector-wrapper.vue?vue&type=style&index=1&id=0c46c15d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c46c15d"]])

export default __exports__